import {
  getAccountsList as getAccountsListApi,
  getAccount as getAccountApi,
  addAccount as addAccountApi,
  updateAccount as updateAccountApi,
  updateAccountStatus as updateAccountStatusApi,
  deleteAccount as deleteAccountApi,
  loginToAccount as loginToAccountAPI,
  loginToImpersonateAccount as loginToImpersonateAccountAPI
} from '../api/global-account.api'
import { getUserData as getUserDataAPI } from '../api/user-management.api'
import { saveUserData } from '../actions/user-management.action'
import { getProjectCategory } from '../actions/global-setting.action'
import idx from 'idx'
import { clearResourcesAction } from '../slice/resources'
import { clearDashboardAction } from '../slice/dashboard'
import { clearCustomersAction } from '../slice/customer'
import { clearCatalogsAction } from '../slice/catalog.slice'
import { clearCategoriesAction } from '../slice/template-category.slice'
import { clearItemsTemplate } from '../slice/template.slice'

export const getAccountsList = (params) => {
  return (dispatch, getState) => {
    return getAccountsListApi(params)
  }
}

export const getAccount = (id) => {
  return (dispatch, getState) => {
    return getAccountApi(id)
  }
}

export const addAccount = (params) => {
  return (dispatch, getState) => {
    return addAccountApi(params)
  }
}

export const updateAccount = (params, id) => {
  return (dispatch, getState) => {
    return updateAccountApi(params, id)
  }
}

export const updateAccountStatus = (params, id) => {
  return (dispatch, getState) => {
    return updateAccountStatusApi(params, id)
  }
}

export const deleteAccount = (params, id) => {
  return (dispatch, getState) => {
    return deleteAccountApi(params, id)
  }
}

export const loginToAccount = (data, name) => {
  return (dispatch, getState) => {
    loginToAccountAPI(data, name).then(async (response) => {
      dispatch(getUserData())
      dispatch(clearResourcesAction())
      dispatch(clearCustomersAction())
      dispatch(clearDashboardAction())
      dispatch(clearCatalogsAction())
      dispatch(clearCategoriesAction())
      dispatch(clearItemsTemplate())
    }).catch(e => {
      return e
    })
  }
}

export const loginToImpersonateAccount = (data, name) => {
  return (dispatch, getState) => {
    return loginToImpersonateAccountAPI(data, name).then(async (response) => {
      await dispatch(getUserData())
      dispatch(clearResourcesAction())
      dispatch(clearCustomersAction())
      dispatch(clearDashboardAction())
      dispatch(clearCatalogsAction())
      dispatch(clearCategoriesAction())
      const finalState = getState();
      return {
        user: finalState.user,
        project: finalState.project,
        projectCategories: finalState.project?.projectCategories,
        isLoggedIn: finalState.user?.isLoggedIn,
      };
    }).catch(e => {
      return e
    })
  }
}

export const getUserData = () => {
  return (dispatch, getState) => {
    return getUserDataAPI().then(async (response) => {
      dispatch(saveUserData(idx(response, _response => _response)))
      await dispatch(getProjectCategory('PROJECTCATEGORIES'))
    }).catch((e) => { })
  }
}
